import React from "react";

import { PaidToLine, PaidToLink } from "./styles";
import { ProgressDetailTextProps } from "./types";

// A payout's own note keeps the main line, so the account link moves below it.
export const ProgressDetailText: React.FC<ProgressDetailTextProps> = ({
  row,
}) => {
  const { paidTo, detail, transaction } = row;
  if (paidTo === null) {
    return <>{detail}</>;
  }
  const link = (
    <>
      Paid to{" "}
      <PaidToLink href={`/accounts/${paidTo.accountId}`}>
        {paidTo.name}
      </PaidToLink>
    </>
  );
  if (!transaction?.note?.trim()) {
    return link;
  }
  return (
    <>
      {detail}
      <PaidToLine>{link}</PaidToLine>
    </>
  );
};
